import React from 'react';
import { _t } from 'app/translations';

const TicketsCategoryEmail = () => {
    return <div>email</div>;
};

export default TicketsCategoryEmail;
